import { render } from "./RestaurantOrderSummary.vue?vue&type=template&id=b7e3a206"
import script from "./RestaurantOrderSummary.vue?vue&type=script&lang=js"
export * from "./RestaurantOrderSummary.vue?vue&type=script&lang=js"

import "./RestaurantOrderSummary.vue?vue&type=style&index=0&id=b7e3a206&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__